

const StartSliderSection = () => {
  return (
    <>
  {/* Start Slider Section */}
  <section
    className="section slider-section-fifteen pt-0 wow fadeInUp"
    data-wow-duration="1s"
  >
    <div
      className="horizontal-slide slide-fifteen  d-flex"
      data-direction="left"
      data-speed="slow"
    >
      <div className="slide-list d-flex gap-4">
        <div className="services-slide">
          <h1>Trauma</h1>
        </div>
        <div className="services-slide">
          <h1>Relationships</h1>
        </div>
        <div className="services-slide">
          <h1>Anxiety</h1>
        </div>
        <div className="services-slide">
          <h1>Stress</h1>
        </div>
      </div>
    </div>
  </section>
  {/* End Slider Section */}
</>

  )
}

export default StartSliderSection